export default __webpack_public_path__ + "static/media/api2.a0756256.jpeg";